import SubscriptionComponent from "../../modules/subscription/subscription";

export default function Subscription() {
    return <SubscriptionComponent role="organization" />;
}